import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { SplatControlComponent } from "./splat-control.component";
import { SplatToolsComponent } from "./splat-control-tools.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        SplatControlComponent,
        SplatToolsComponent
    ],
    exports: [
        SplatControlComponent
    ],
    entryComponents: [
        SplatToolsComponent
    ]
})
export class SplatControlModule {}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/splat-control.module.ts